import PropTypes from 'prop-types';
import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';

import AddressForm from '../../components/AddressForm';
import classNames from './EditableUserAddressPanel.module.scss';

const ADDRESS_FIELD_NAMES = {
  streetOne: 'newUser_streetOne',
  streetTwo: 'newUser_streetTwo',
  city: 'newUser_city',
  postalCode: 'newUser_postalCode',
  state: 'newUser_state',
  country: 'newUser_country',
};

const NewUserAddressForm = ({ t, form, onAddressChange, isLoading, addressValues }) => {
  const supportedCountries = useSelector(store => store.common.supportedCountries);

  const filteredCountries = (supportedCountries || []).filter(
    country => country.code === 'US' || country.code === 'CA',
  );

  useEffect(() => {
    const fieldsToSet = {};
    Object.keys(ADDRESS_FIELD_NAMES).forEach(key => {
      const namespacedKey = ADDRESS_FIELD_NAMES[key];
      if (addressValues[key] !== undefined) {
        fieldsToSet[namespacedKey] = addressValues[key];
      }
    });

    if (Object.keys(fieldsToSet).length > 0) {
      form.setFieldsValue(fieldsToSet);
    }
  }, [addressValues, form]);

  const handleAddressFieldChange = updatedFields => {
    const currentFormValues = form.getFieldsValue(Object.values(ADDRESS_FIELD_NAMES));

    // Convert namespaced form values back to standard keys
    const currentAddressValues = {};
    Object.keys(ADDRESS_FIELD_NAMES).forEach(key => {
      currentAddressValues[key] = currentFormValues[ADDRESS_FIELD_NAMES[key]];
    });

    const updatedAddress = {
      ...currentAddressValues,
      ...updatedFields,
    };

    // Manually update namespaced form fields to ensure validation passes
    // (AddressForm's onChange override prevents automatic binding)
    const namespacedUpdates = {};
    Object.keys(updatedFields).forEach(key => {
      const namespacedKey = ADDRESS_FIELD_NAMES[key];
      if (namespacedKey) {
        namespacedUpdates[namespacedKey] = updatedFields[key];
      }
    });
    form.setFieldsValue(namespacedUpdates);

    onAddressChange(updatedAddress);
  };

  return (
    <div className={classNames.editableUserAddressPanel}>
      <div className={classNames.content}>
        <div className={classNames.header}>
          <strong>{t('address')}</strong>
        </div>
        <div className={classNames.formFields}>
          <AddressForm
            t={t}
            formInstance={form}
            values={addressValues}
            countries={filteredCountries}
            onValueChange={handleAddressFieldChange}
            formDisabled={isLoading}
            allFieldsOptional={false}
            fieldNames={ADDRESS_FIELD_NAMES}
            hiddenFields={['streetTwo']}
            isEmbedded
          />
        </div>
      </div>
    </div>
  );
};

NewUserAddressForm.propTypes = {
  t: PropTypes.func.isRequired,
  form: PropTypes.object.isRequired,
  onAddressChange: PropTypes.func.isRequired,
  isLoading: PropTypes.bool,
  addressValues: PropTypes.object,
};

NewUserAddressForm.defaultProps = {
  isLoading: false,
  addressValues: {},
};

export default NewUserAddressForm;
